import { WhatsAppParser } from '../parser/whatsappParser';
import { Chat } from '../types';

// List of chat files in public/chats/
const CHAT_FILES = [
  'Jathar.txt',
  'Kuposhit.txt',
  'Nish.txt',
  'Rabdi.txt'
];

// Helper to generate simple IDs
function generateId(): string {
  return Math.random().toString(36).substring(2) + Date.now().toString(36);
}

export async function loadPublicChats(): Promise<Chat[]> {
  const chats: Chat[] = [];
  const parser = new WhatsAppParser(['Prabhu', 'Pratik Bhuite']);
  
  for (const filename of CHAT_FILES) {
    try {
      const response = await fetch(`/chats/${filename}`);
      if (!response.ok) {
        console.error(`Failed to load ${filename}:`, response.statusText);
        continue;
      }
      
      const text = await response.text();
      const chatId = generateId();
      const chat = parser.parseChat(text, filename, chatId);
      
      if (chat && chat.messages.length > 0) {
        chats.push(chat);
      }
    } catch (error) {
      console.error(`Error loading ${filename}:`, error);
    }
  }
  
  return chats;
}

// Get chat file names for dynamic loading
export function getChatFileNames(): string[] {
  return CHAT_FILES;
}
